function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { PixiComponent } from '@inlet/react-pixi';
import * as R from 'unitx/ramda';
import { wrapComponent } from 'unitx-ui';
import * as PIXI from 'pixi.js';
import { applyDefaultProps, getTextureFromProps, preprocessProps } from "../../utils";
const ImagePIXI = PixiComponent('Image', {
  create: props => {
    const instance = new PIXI.Sprite(getTextureFromProps('Sprite', props)); // instance.width = 10
    // instance.height = 10

    /* eslint-disable functional/immutable-data, functional/no-expression-statement */
    // instance.interactive = true

    /* eslint-enable functional/immutable-data, functional/no-expression-statement */

    return instance;
  },
  applyProps: (mutableInstance, oldProps, _props) => {
    var _oldProps$source;

    /* eslint-disable functional/immutable-data, functional/no-expression-statement */
    const props = preprocessProps(_props);

    const {
      // image,
      // texture,
      source
    } = props,
          restProps = _objectWithoutProperties(props, ["source"]);

    const isUriSource = R.has('uri')(source);
    R.when(R.anyPass([R.always(isUriSource && source.uri !== ((_oldProps$source = oldProps.source) === null || _oldProps$source === void 0 ? void 0 : _oldProps$source.uri)), R.always(source !== oldProps.source)]), () => {
      mutableInstance.texture = getTextureFromProps('Sprite', props);
    })(source);
    applyDefaultProps(mutableInstance, oldProps, restProps, {
      rescaleToYoga: true
    });
    /* eslint-enable functional/immutable-data, functional/no-expression-statement */
  }
});

function Image(props) {
  return /*#__PURE__*/React.createElement(ImagePIXI, props);
}
/**
 * ## Usage
 * To use Image on Graph
 * Check example
 *
 * ```js live=true
 * <Graph
 *  style={{ width: '100%', height: 250 }}
 *  nodes={[
 *    {
 *      id: 1,
 *      position: { x: 10, y: 10 },
 *      data: {
 *        image: 'https://www.biography.com/.image/t_share/MTE4MDAzNDEwNTEzMDA0MDQ2/thomas-edison-9284349-1-402.jpg'
 *       }
 *    },
 *    {
 *      id: 2,
 *      position: { x: 300, y: 10 },
 *      data: {
 *        image: 'https://images.unsplash.com/photo-1552529232-9e6cb081de19?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60'
 *      }
 *    },
 *  ]}
 *  edges={[
 *    { id: 51, source: 1, target: 2 }
 *  ]}
 *  renderNode={({ item: { data } }) => (
 *    <Graph.Image
 *      style={{ width: 100, height: 100 }}
 *      source={{ uri: data.image }}
 *    />
 * )}
 * />
 * ```
 */


export default wrapComponent(Image);